<template>
  <div>
    <div v-for="(item, index) of carreraslist2" :key="index" class="item">
      <div v-if="horarios.roles[0].rol == 'Docente'">
        <b> {{ item.periodo.nombre }}</b>
      </div>
      <div class="nota-horarios" v-else>
        Programa:
        <b>{{ item.programaAcademico.nombre }}</b> Modalidad:
        <b> {{ item.modalidad.nombre }}</b>
      </div>
      <br />
    </div>
    <div class="row">
      <div class="column">
        <div class="dia-horario">Lunes</div>

        <div v-for="(item, index) of lunesPresencial" :key="index" class="item">
          <div class="card">
            <div class="container">
              <h6>
                <b>{{ item.curso }}</b>
              </h6>
              <div class="alert alert-primary" role="alert">
                <div v-if="item.tipoReunionNombre === 'TUTORIA OPTATIVA'">
                  {{ item.tipoReunionNombre.substring(0, 8) }}
                </div>
                <div v-else>
                  {{ item.tipoReunionNombre }}
                </div>
              </div>

              <ul class="horario-dia">
                <li>
                  <b
                    ><center>
                      {{ item.hora_inicio }} -{{ item.hora_fin }}
                    </center></b
                  >
                </li>

                <li>
                  <center>{{ item.aula }}</center>
                </li>
                <li>
                  <center>{{ item.paralelo }}</center>
                </li>
                <li>
                  <center>{{ item.docente }}</center>
                </li>
                <li>
                  <center>
                    <div
                      class="enlace_turoria"
                      v-if="item.enlaceTutoria !== ''"
                    >
                      <a :href="item.enlaceTutoria">Zoom</a>
                    </div>
                  </center>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="dia-horario">Martes</div>
        <div
          v-for="(item, index) of martesPresencial"
          :key="index"
          class="item"
        >
          <div class="card">
            <div class="container">
              <h6>
                <b>{{ item.curso }}</b>
              </h6>
              <div class="alert alert-primary" role="alert">
                <div v-if="item.tipoReunionNombre === 'TUTORIA OPTATIVA'">
                  {{ item.tipoReunionNombre.substring(0, 8) }}
                </div>
                <div v-else>
                  {{ item.tipoReunionNombre }}
                </div>
              </div>
              <ul class="horario-dia">
                <li>
                  <b
                    ><center>
                      {{ item.hora_inicio }} -{{ item.hora_fin }}
                    </center></b
                  >
                </li>

                <li>
                  <center>{{ item.aula }}</center>
                </li>
                 <li>
                  <center>{{ item.paralelo }}</center>
                </li>
                <li>
                  <center>{{ item.docente }}</center>
                </li>
                <li>
                  <center>
                    <div
                      class="enlace_turoria"
                      v-if="item.enlaceTutoria !== ''"
                    >
                      <a :href="item.enlaceTutoria">Zoom</a>
                    </div>
                  </center>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="dia-horario">Miércoles</div>
        <div
          v-for="(item, index) of miercolesPresencial"
          :key="index"
          class="item"
        >
          <div class="card">
            <div class="container">
              <h6>
                <b>{{ item.curso }}</b>
              </h6>
              <div class="alert alert-primary" role="alert">
                <div v-if="item.tipoReunionNombre === 'TUTORIA OPTATIVA'">
                  {{ item.tipoReunionNombre.substring(0, 8) }}
                </div>
                <div v-else>
                  {{ item.tipoReunionNombre }}
                </div>
              </div>
              <ul class="horario-dia">
                <li>
                  <b
                    ><center>
                      {{ item.hora_inicio }} -{{ item.hora_fin }}
                    </center></b
                  >
                </li>

                <li>
                  <center>{{ item.aula }}</center>
                </li>
                <li>
                  <center>{{ item.paralelo }}</center>
                </li>
                <li>
                  <center>{{ item.docente }}</center>
                </li>
                <li>
                  <center>
                    <div
                      class="enlace_turoria"
                      v-if="item.enlaceTutoria !== ''"
                    >
                      <a :href="item.enlaceTutoria">Zoom</a>
                    </div>
                  </center>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="dia-horario">Jueves</div>
        <div
          v-for="(item, index) of juevesPresencial"
          :key="index"
          class="item"
        >
          <div class="card">
            <div class="container">
              <h6>
                <b>{{ item.curso }}</b>
              </h6>
              <div class="alert alert-primary" role="alert">
                <div v-if="item.tipoReunionNombre === 'TUTORIA OPTATIVA'">
                  {{ item.tipoReunionNombre.substring(0, 8) }}
                </div>
                <div v-else>
                  {{ item.tipoReunionNombre }}
                </div>
              </div>
              <ul class="horario-dia">
                <li>
                  <b
                    ><center>
                      {{ item.hora_inicio }} -{{ item.hora_fin }}
                    </center></b
                  >
                </li>

                <li>
                  <center>{{ item.aula }}</center>
                </li>
                 <li>
                  <center>{{ item.paralelo }}</center>
                </li>
                <li>
                  <center>{{ item.docente }}</center>
                </li>
                <li>
                  <center>
                    <div
                      class="enlace_turoria"
                      v-if="item.enlaceTutoria !== ''"
                    >
                      <a :href="item.enlaceTutoria">Zoom</a>
                    </div>
                  </center>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="dia-horario">Viernes</div>
        <div
          v-for="(item, index) of viernesPresencial"
          :key="index"
          class="item"
        >
          <div class="card">
            <div class="container">
              <h6>
                <b>{{ item.curso }}</b>
              </h6>
              <div class="alert alert-primary" role="alert">
                <div v-if="item.tipoReunionNombre === 'TUTORIA OPTATIVA'">
                  {{ item.tipoReunionNombre.substring(0, 8) }}
                </div>
                <div v-else>
                  {{ item.tipoReunionNombre }}
                </div>
              </div>
              <ul class="horario-dia">
                <li>
                  <b
                    ><center>
                      {{ item.hora_inicio }} -{{ item.hora_fin }}
                    </center></b
                  >
                </li>

                <li>
                  <center>{{ item.aula }}</center>
                </li>
                 <li>
                  <center>{{ item.paralelo }}</center>
                </li>
                <li>
                  <center>{{ item.docente }}</center>
                </li>
                <li>
                  <center>
                    <div
                      class="enlace_turoria"
                      v-if="item.enlaceTutoria !== ''"
                    >
                      <a :href="item.enlaceTutoria">Zoom</a>
                    </div>
                  </center>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="dia-horario">Sábado</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

const config = {
  headers: { 
    apikey:
      "eyJ4NXQiOiJOVGRtWmpNNFpEazNOalkwWXpjNU1tWm1PRGd3TVRFM01XWXdOREU1TVdSbFpEZzROemM0WkE9PSIsImtpZCI6ImdhdGV3YXlfY2VydGlmaWNhdGVfYWxpYXMiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJVVFBMLkVEVS5FQ1wvYWNjYXJkZW5hczRAY2FyYm9uLnN1cGVyIiwiYXBwbGljYXRpb24iOnsib3duZXIiOiJVVFBMLkVEVS5FQ1wvYWNjYXJkZW5hczQiLCJ0aWVyUXVvdGFUeXBlIjpudWxsLCJ0aWVyIjoiVW5saW1pdGVkIiwibmFtZSI6IkhvcmFyaW9zQ2FudmFzIiwiaWQiOjE0NDMsInV1aWQiOiIxZDhjZjlhZi0xZjg1LTQ1OTAtYjUzMC01YTRmOGQzNDhkY2QifSwiaXNzIjoiaHR0cHM6XC9cL3Nydi1zaS0wMDEudXRwbC5lZHUuZWM6NDQzXC9vYXV0aDJcL3Rva2VuIiwidGllckluZm8iOnsiQnJvbnplIjp7InRpZXJRdW90YVR5cGUiOiJyZXF1ZXN0Q291bnQiLCJncmFwaFFMTWF4Q29tcGxleGl0eSI6MCwiZ3JhcGhRTE1heERlcHRoIjowLCJzdG9wT25RdW90YVJlYWNoIjp0cnVlLCJzcGlrZUFycmVzdExpbWl0IjowLCJzcGlrZUFycmVzdFVuaXQiOm51bGx9fSwia2V5dHlwZSI6IlBST0RVQ1RJT04iLCJwZXJtaXR0ZWRSZWZlcmVyIjoiIiwic3Vic2NyaWJlZEFQSXMiOlt7InN1YnNjcmliZXJUZW5hbnREb21haW4iOiJjYXJib24uc3VwZXIiLCJuYW1lIjoiTmV0Q29yZUFwaSIsImNvbnRleHQiOiJcL2FwaW1cL25ldGNvcmVcLzEuMCIsInB1Ymxpc2hlciI6IlVUUEwuRURVLkVDXC9qc2NhbGRlcm9uIiwidmVyc2lvbiI6IjEuMCIsInN1YnNjcmlwdGlvblRpZXIiOiJCcm9uemUifV0sInBlcm1pdHRlZElQIjoiIiwiaWF0IjoxNjY2MDI4ODcxLCJqdGkiOiJkZTlmMzVlZi1hYjY1LTRlMDEtYjIwNy02MTU3ZjA4ZWRmNmIifQ==.SwaWrejmsrOAkmMpoW2CTJGMQGigfyVa0LaJ7nd8X-lt6F5sTOPPcYnEmElTCFTJvQNoSQegvvd-7ySmwPcY7WHYyatRh-QzzfUGySeZvlQeSTBVjrZJJxZDEJwnvNtqdyF4b031A3Ol7cF878Kl6yCWwgSbgniI9m27NbpB_B4oU2T4rZNvTBCvy4uSKNYBNqBHhoqRqYz480Xe3Whu1pCSXHlq6Yf0w-pSkwT6n8glKD-cNR70OBkaX_-jFFO7YkML0ZYm6_ZehlikvP0ZeyL4g22tYDYqBV79WhWl0vdLDWOZqhGtx4nguNAdKh-Hn7BBlnhl_zKls283rtbQew==",
  },
};

export default {
  name: "utpl-horarios-canvas",
  data() {
    return {
      cargos: [],
      horarios: {},
      carreraslist: {},
      carreraslist2: {},
      horariosCanvas: {},
      lunesPresencial: [],
      martesPresencial: [],
      miercolesPresencial: [],
      juevesPresencial: [],
      viernesPresencial: [],
      sabadoPresencial: [],
    };
  },

  props: {
    usuario: {
      type: String,
      default: "",
    },
  },
  methods: {
    gethorarios() {
      axios
        .get(
          "https://srv-si-001.utpl.edu.ec/apim/netcore/1.0/api/services/app/HorarioPersona/GetHorarioPersonaPeriodoActual?periodoCodigo=202690&input="+this.usuario ,
          config
        )
        .then((response) => {
          const lunesPresencial = [];
          const martesPresencial = [];
          const miercolesPresencial = [];
          const juevesPresencial = [];
          const viernesPresencial = [];
          const sabadoPresencial = [];
          const domingoPresencial = [];
          const horarios = response.data;
          this.horarios = horarios.result;

          for (let roles of this.horarios.roles) {
            for (let carreras of roles.carreras) {
              this.carreraslist2 = roles.carreras;
              for (let cursos of carreras.cursos) {
                for (let paralelos of cursos.paralelos) {
                  for (let horarios of paralelos.horarios) {
                    if (horarios.dia === "LUNES") {
                      Vue.set(horarios, "rol", roles.rol);
                      Vue.set(horarios, "curso", cursos.nombre);
                      Vue.set(horarios, "modalidad", cursos.modalidad);
                      Vue.set(horarios, "paralelo", "Paralelo: "+ paralelos.paralelo);

                      this.lunesPresencial.push(horarios);
                      this.lunesPresencial.sort((a, b) => a.curso - b.curso);
                    }
                    if (horarios.dia === "MARTES") {
                      Vue.set(horarios, "rol", roles.rol);
                      Vue.set(horarios, "curso", cursos.nombre);
                      Vue.set(horarios, "modalidad", cursos.modalidad);
                      Vue.set(horarios, "paralelo", "Paralelo: "+paralelos.paralelo);
                      this.martesPresencial.push(horarios);
                    }
                    if (horarios.dia === "MIERCOLES") {
                      Vue.set(horarios, "rol", roles.rol);
                      Vue.set(horarios, "curso", cursos.nombre);
                      Vue.set(horarios, "modalidad", cursos.modalidad);
                      Vue.set(horarios, "paralelo", "Paralelo: "+paralelos.paralelo);
                      this.miercolesPresencial.push(horarios);
                    }
                    if (horarios.dia === "JUEVES") {
                      Vue.set(horarios, "rol", roles.rol);
                      Vue.set(horarios, "curso", cursos.nombre);
                      Vue.set(horarios, "modalidad", cursos.modalidad);
                      Vue.set(horarios, "paralelo", "Paralelo: "+paralelos.paralelo);
                      this.juevesPresencial.push(horarios);
                    }
                    if (horarios.dia === "VIERNES") {
                      Vue.set(horarios, "rol", roles.rol);
                      Vue.set(horarios, "curso", cursos.nombre);
                      Vue.set(horarios, "modalidad", cursos.modalidad);
                      Vue.set(horarios, "paralelo", "Paralelo: "+paralelos.paralelo);
                      this.viernesPresencial.push(horarios);
                    }
                    if (horarios.dia === "SABADO") {
                      Vue.set(horarios, "rol", roles.rol);
                      Vue.set(horarios, "curso", cursos.nombre);
                      Vue.set(horarios, "modalidad", cursos.modalidad);
                      Vue.set(horarios, "paralelo",paralelos.paralelo);
                      this.sabadoPresencial.push(horarios);
                    }
                    if (horarios.dia === "DOMINGO") {
                      Vue.set(horarios, "rol", roles.rol);
                      Vue.set(horarios, "curso", cursos.nombre);
                      Vue.set(horarios, "modalidad", cursos.modalidad);
                      Vue.set(horarios, "paralelo", paralelos.paralelo);
                      this.domingoPresencial.push(horarios);
                    }
                  }
                }
              }
            }
          }
         
          return (
            lunesPresencial,
            martesPresencial,
            miercolesPresencial,
            juevesPresencial,
            viernesPresencial,
            sabadoPresencial,
            domingoPresencial
          );
        });
    },
  
  },
  mounted() {
    this.gethorarios();
  },
};
</script>
<style>
@import "../styles/style-horarios-canvas.css";
</style>
